import React from 'react';
import SEO from '../components/SEO/SEO';
import Hero from '../components/Sections/Hero';
import About from '../components/Sections/About';
import Bio from '../components/Sections/Bio';
import HealingGrid from '../components/Sections/HealingGrid';
import ProcessSteps from '../components/Sections/ProcessSteps';
import WhatToExpect from '../components/Sections/WhatToExpect';
import WhoUsesIt from '../components/Sections/WhoUsesIt-2';
import Services from '../components/Sections/Services';
import Testimonials from '../components/Sections/Testimonials';
import Contact from '../components/Sections/Contact';

const Home = () => {
  return (
    <>
      <SEO />
      <Hero />
      <About />
      <ProcessSteps />
      <WhoUsesIt />
      <HealingGrid />
      <WhatToExpect />
      <Bio />
      <Services />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
